import { DirectAccessCourseResponse } from '../Types/DirectAccessCourseResponse';
import { courseDetailsInitState } from './DirectAccessInitState';
import { IAction } from '../../../__core/Interfaces/IAction';
import DIRECT_ACCESS_ACTIONS from '../Actions/ActionTypes';

export const directAccessCourseReducer = (
  state: DirectAccessCourseResponse = courseDetailsInitState,
  action: IAction<DirectAccessCourseResponse>
): DirectAccessCourseResponse => {
  switch (action.type) {
    case DIRECT_ACCESS_ACTIONS.DIRECT_ACCESS_FETCH_COURSE:
      return { ...action.payload };

    default:
      return state;
  }
};
